const newActionHeader = {
  label: 'CRIAR UMA PUBLICAÇÃO'
};

export default newActionHeader;
